import { ReactComponent as BouncingArrow } from 'icons/symbols/jumping-arrow.svg';

const Symbols = {
    BouncingArrow,
};

export default Symbols;
